/**
 * API base URL for the SPA (module 0.3 — Cloudflare Pages + Workers).
 *
 * In dev the API is same-origin: the Vite proxy forwards `/api/*` to the local
 * API server, so the base stays `''` (relative) and nothing here activates.
 * In production the SPA is served from Cloudflare Pages while the API lives on
 * a Cloudflare Workers domain — CI injects the Workers URL at build time as
 * `VITE_API_URL`, and App.tsx threads it into every lib client's `baseUrl`
 * option. Never hardcode localhost or a deploy URL in source (L3).
 */
export function apiBaseUrl(
  env: Record<string, string | undefined> = import.meta.env as unknown as Record<
    string,
    string | undefined
  >,
): string {
  const raw = env.VITE_API_URL;
  if (!raw) return '';
  // Lib clients concatenate `${baseUrl}/api/...` — a trailing slash would
  // produce `//api/...` (a protocol-relative URL, i.e. a different host).
  return raw.replace(/\/+$/, '');
}
